// Checklist de documentos faltantes priorizados para el cliente
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline';
import type { FaltantePriorizado } from '@/types/clienteFicha';

interface Props {
  faltantes: FaltantePriorizado[];
}

export function ClienteChecklistProgress({ faltantes }: Props) {
  if (!faltantes.length) {
    return (
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3 text-green-600 dark:text-green-400">
            <CheckCircleIcon className="h-8 w-8" />
            <div>
              <p className="font-semibold">Documentación completa</p>
              <p className="text-sm text-gray-500">Has aportado toda la documentación necesaria.</p>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  const obligatorios = faltantes.filter(f => f.severidad === 'hard' || !f.severidad);
  const opcionales = faltantes.filter(f => f.severidad === 'soft');

  return (
    <Card>
      <CardContent className="pt-6 space-y-4">
        <h3 className="font-semibold text-gray-900 dark:text-gray-100">
          Documentación pendiente ({faltantes.length})
        </h3>

        {obligatorios.length > 0 && (
          <div className="space-y-2">
            <p className="text-xs font-medium text-red-600 dark:text-red-400 uppercase tracking-wide">
              Obligatorios
            </p>
            {obligatorios.map((item) => (
              <div
                key={item.codigo}
                className="flex items-start gap-3 p-3 bg-red-50 dark:bg-red-950 border border-red-200 dark:border-red-800 rounded-lg"
              >
                <ExclamationCircleIcon className="h-5 w-5 text-red-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{item.nombre}</p>
                  {item.descripcion && (
                    <p className="text-xs text-gray-600 dark:text-gray-400 mt-0.5">{item.descripcion}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {opcionales.length > 0 && (
          <div className="space-y-2">
            <p className="text-xs font-medium text-amber-600 dark:text-amber-400 uppercase tracking-wide">
              Opcionales
            </p>
            {opcionales.map((item) => (
              <div
                key={item.codigo}
                className="flex items-start gap-3 p-3 bg-amber-50 dark:bg-amber-950 border border-amber-200 dark:border-amber-800 rounded-lg"
              >
                <ExclamationCircleIcon className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{item.nombre}</p>
                  {item.descripcion && (
                    <p className="text-xs text-gray-600 dark:text-gray-400 mt-0.5">{item.descripcion}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
